import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ParticleNetwork from "./components/ParticleNetwork";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import QuarterlyTrainingsPage from "./pages/QuarterlyTrainingsPage";
import TrainingDetailPage from "./pages/TrainingDetailPage";
import TrainingsArchivePage from "./pages/TrainingsArchivePage";
import CohortsPage from "./pages/CohortsPage";
import CohortDetailPage from "./pages/CohortDetailPage";
import CohortsArchivePage from "./pages/CohortsArchivePage";
import PodcastPage from "./pages/PodcastPage";
import LiveSessionsPage from "./pages/LiveSessionsPage";
import SessionDetailPage from "./pages/SessionDetailPage";
import SessionsArchivePage from "./pages/SessionsArchivePage";
import ToolDemoPage from "./pages/ToolDemoPage";
import ToolDetailPage from "./pages/ToolDetailPage";
import ToolDemoArchivePage from "./pages/ToolDemoArchivePage";
import CorporatePage from "./pages/CorporatePage";
import CorporateDetailPage from "./pages/CorporateDetailPage";
import CorporateArchivePage from "./pages/CorporateArchivePage";
import StudyGroupsPage from "./pages/StudyGroupsPage";
import StudyGroupDetailPage from "./pages/StudyGroupDetailPage";
import StudyGroupsArchivePage from "./pages/StudyGroupsArchivePage";
import TrainingRegisterPage from "./pages/TrainingRegisterPage";
import FAQPage from "./pages/FAQPage";
import VulnconPreviewPage from "./pages/VulnconPreviewPage";
import TrainerProposalPage from "./pages/TrainerProposalPage";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <ParticleNetwork />
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/quarterly-trainings" element={<QuarterlyTrainingsPage />} />
              <Route path="/services/quarterly-trainings/archive" element={<TrainingsArchivePage />} />
              <Route path="/services/quarterly-trainings/register" element={<TrainingRegisterPage />} />
              <Route path="/services/quarterly-trainings/:id" element={<TrainingDetailPage />} />
              <Route path="/services/cohorts" element={<CohortsPage />} />
              <Route path="/services/cohorts/archive" element={<CohortsArchivePage />} />
              <Route path="/services/cohorts/:id" element={<CohortDetailPage />} />
              <Route path="/services/podcast" element={<PodcastPage />} />
              <Route path="/services/live-sessions" element={<LiveSessionsPage />} />
              <Route path="/services/live-sessions/archive" element={<SessionsArchivePage />} />
              <Route path="/services/live-sessions/:id" element={<SessionDetailPage />} />
              <Route path="/services/tool-demos" element={<ToolDemoPage />} />
              <Route path="/services/tool-demos/archive" element={<ToolDemoArchivePage />} />
              <Route path="/services/tool-demos/:id" element={<ToolDetailPage />} />
              <Route path="/services/corporate" element={<CorporatePage />} />
              <Route path="/services/corporate/archive" element={<CorporateArchivePage />} />
              <Route path="/services/corporate/:id" element={<CorporateDetailPage />} />
              <Route path="/services/study-groups" element={<StudyGroupsPage />} />
              <Route path="/services/study-groups/archive" element={<StudyGroupsArchivePage />} />
              <Route path="/services/study-groups/:id" element={<StudyGroupDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/preview/vulncon" element={<VulnconPreviewPage />} />
              <Route path="/trainer-proposal" element={<TrainerProposalPage />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
